// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.data-table .v-data-table-header {\n  vertical-align: top;\n}\n", ""]);
// Exports
module.exports = exports;
